require('../../fhApp/currentUser/currentUser');
require('../../fhApp/appMetaService');

"use strict";

angular.module('app.mainFrame.collapsableMenu.collapsableMenuService', [
  'app.currentUser',
  'app.appMetaService'
])
  .factory('app.mainFrame.collapsableMenu.collapsableMenuService', [
    '$state',
    'currentUser',
    '$rootScope',
    'appMetaService',
    function ($state, currentUser, $rootScope, appMeta) {
      let service = {
        items: {},
        menuExpanded: false,
        prependedGroups: null,
        buildItems: function (prepend_groups) {
          service.items = {};

          let collapsable_menu = {
            accountSettings: null
          };

          if (typeof prepend_groups === 'undefined') {
            prepend_groups = service.prependedGroups;
          }
          else {
            service.prependedGroups = prepend_groups;
          }

          if (prepend_groups) {
            angular.merge(service.items, prepend_groups);
          }

          angular.merge(service.items, collapsable_menu);

          if (currentUser.is_logged_in()) {
            //service.items.accountSettings = [];

            /*if(!currentUser.data.has_all_acc_info) {
              service.items.accountSettings.push({
                label: 'Log Out',
                action: function () {
                  currentUser.logout();
                  $state.go('welcome.default');
                  $rootScope.$broadcast('collapsableMenuTriggerCollapse');
                }
              });
            } else {*/
            service.items.accountSettings = [
              {
                label: 'Billing Info',
                icon: 'fa fa-dollar',
                action: function () {
                  $state.go('app.purchase.billingInfo');
                  $rootScope.$broadcast('collapsableMenuTriggerCollapse');
                }
              },
              {
                label: 'My Account',
                icon: 'fa fa-user-circle',
                action: function () {
                  $state.go('app.accountSettings');
                  $rootScope.$broadcast('collapsableMenuTriggerCollapse');
                }
              },
              {

                label: 'Broadcast Status',
                icon: 'fa fa-heartbeat',
                action: function () {
                  $state.go('app.broadcastStatus');
                  $rootScope.$broadcast('collapsableMenuTriggerCollapse');
                }
              },
              {

                label: 'Roku Connect',
                icon: 'fa fa-registered',
                action: function () {
                  $state.go('app.rokuConnect');
                  $rootScope.$broadcast('collapsableMenuTriggerCollapse');
                }
              },
              {
                label: 'Support',
                icon: 'fa fa-question-circle',
                action: function () {
                  window.open(appMeta.supportSite);
                }
              },
              {
                label: 'Sign Out',
                icon: 'fa fa-sign-out',
                action: function () {
                  currentUser.logout();
                  $state.go('welcome');
                  $rootScope.$broadcast('collapsableMenuTriggerCollapse');
                }
              }
            ];
            // }
          }
          else {
            service.items.accountSettings = [
              {
                label: 'Sign In',
                icon: 'fa fa-sign-in',
                action: function () {
                  $state.go('app.login');
                  $rootScope.$broadcast('collapsableMenuTriggerCollapse');
                }
              },
              {
                label: 'Sign Up',
                icon: 'fa fa-user-plus',
                action: function () {
                  $state.go('app.registration.new');
                  $rootScope.$broadcast('collapsableMenuTriggerCollapse');
                }
              },
              {
                label: 'Support',
                icon: 'fa fa-question-circle',
                action: function () {
                  window.open(appMeta.supportSite);
                }
              }
            ];
          }
        }
      };

      return service;
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/mainFrame/collapsableMenu/collapsableMenuService.js